import React from "react";
import { Row, Col, Card, Button, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faStore,
  faCheckCircle,
  faTimesCircle,
  faExclamationTriangle,
  faChevronUp
} from "@fortawesome/free-solid-svg-icons";

const ShopStatusSection = ({ 
  selectedReport, 
  sectionVisibility, 
  onToggleSection, 
  onHandleShopListModal 
}) => {
  if (!sectionVisibility.shopStatus) return null;

  return (
    <>
      {/* Shop Status Overview - Critical First */}
      <Row className="mb-4">
        <Col md={12}>
          <Card className="shadow-sm report-card">
            <Card.Header className="bg-light">
              <Row className="align-items-center">
                <Col>
                  <h6 className="mb-0">
                    <FontAwesomeIcon icon={faStore} className="me-2" />
                    Status drogerii - przegląd operacyjny
                  </h6>
                </Col>
                <Col xs="auto">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => onToggleSection('shopStatus')}
                    title="Zwiń sekcję"
                  >
                    <FontAwesomeIcon icon={faChevronUp} />
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row>
                {/* Drogerie Otwarte */}
                <Col lg={3} md={6} className="mb-3">
                  <div className="text-center p-3 border rounded" style={{borderLeft: '4px solid #28a745'}}>
                    <FontAwesomeIcon icon={faCheckCircle} size="2x" className="text-success mb-2" />
                    <h4 className="mb-1 text-success">{selectedReport.data?.shopsOpenedCount || 0}</h4>
                    <p className="text-muted mb-1 small"><strong>OTWARTE</strong></p>
                    {selectedReport.data?.shopsOpenedWithNoDevices?.length > 0 && (
                      <Badge 
                        bg="warning" 
                        className="small clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie otwarte - bez urządzeń', 
                          selectedReport.data.shopsOpenedWithNoDevices,
                          'Otwarte bez urządzeń'
                        )}
                      >
                        {selectedReport.data.shopsOpenedWithNoDevices.length} bez urządzeń
                      </Badge>
                    )}
                    {selectedReport.data?.shopsOpenedWithNotRespondingDevices?.length > 0 && (
                      <Badge 
                        bg="danger" 
                        className="small ms-1 clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie otwarte - problemy komunikacji', 
                          selectedReport.data.shopsOpenedWithNotRespondingDevices,
                          'Otwarte z problemami komunikacji'
                        )}
                      >
                        {selectedReport.data.shopsOpenedWithNotRespondingDevices.length} z problemami
                      </Badge>
                    )}
                  </div>
                </Col>

                {/* Drogerie Zamknięte */}
                <Col lg={3} md={6} className="mb-3">
                  <div className="text-center p-3 border rounded" style={{borderLeft: '4px solid #6c757d'}}>
                    <FontAwesomeIcon icon={faTimesCircle} size="2x" className="text-secondary mb-2" />
                    <h4 className="mb-1 text-secondary">{selectedReport.data?.shopsClosedCount || 0}</h4>
                    <p className="text-muted mb-1 small"><strong>ZAMKNIĘTE</strong></p>
                    {selectedReport.data?.shopsClosedWithDevices?.length > 0 && (
                      <Badge 
                        bg="warning" 
                        className="small clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie zamknięte - z urządzeniami', 
                          selectedReport.data.shopsClosedWithDevices,
                          'Zamknięte z urządzeniami'
                        )}
                      >
                        {selectedReport.data.shopsClosedWithDevices.length} z urządzeniami
                      </Badge>
                    )}
                  </div>
                </Col>

                {/* Drogerie w Remoncie */}
                <Col lg={3} md={6} className="mb-3">
                  <div className="text-center p-3 border rounded" style={{borderLeft: '4px solid #ffc107'}}>
                    <FontAwesomeIcon icon={faExclamationTriangle} size="2x" className="text-warning mb-2" />
                    <h4 className="mb-1 text-warning">{selectedReport.data?.shopsInRenovation || 0}</h4>
                    <p className="text-muted mb-1 small"><strong>W REMONCIE</strong></p>
                    <div className="d-flex justify-content-center gap-1 flex-wrap">
                      {selectedReport.data?.shopsInRenovationWithDevices?.length > 0 && (
                        <Badge 
                          bg="info" 
                          className="small clickable-badge"
                          style={{cursor: 'pointer'}}
                          onClick={() => onHandleShopListModal(
                            'Drogerie w remoncie - z urządzeniami', 
                            selectedReport.data.shopsInRenovationWithDevices,
                            'W remoncie z urządzeniami'
                          )}
                        >
                          {selectedReport.data.shopsInRenovationWithDevices.length} z urządzeniami
                        </Badge>
                      )}
                      {selectedReport.data?.shopsInRenovationWithoutDevices?.length > 0 && (
                        <Badge 
                          bg="secondary" 
                          className="small clickable-badge"
                          style={{cursor: 'pointer'}}
                          onClick={() => onHandleShopListModal(
                            'Drogerie w remoncie - bez urządzeń', 
                            selectedReport.data.shopsInRenovationWithoutDevices,
                            'W remoncie bez urządzeń'
                          )}
                        >
                          {selectedReport.data.shopsInRenovationWithoutDevices.length} bez urządzeń
                        </Badge>
                      )}
                    </div>
                  </div>
                </Col>

                {/* Drogerie po Remoncie */}
                <Col lg={3} md={6} className="mb-3">
                  <div className="text-center p-3 border rounded" style={{borderLeft: '4px solid #17a2b8'}}>
                    <FontAwesomeIcon icon={faCheckCircle} size="2x" className="text-info mb-2" />
                    <h4 className="mb-1 text-info">{selectedReport.data?.shopsAfterRenovation?.length || 0}</h4>
                    <p className="text-muted mb-1 small"><strong>PO REMONCIE</strong></p>
                    {selectedReport.data?.shopsAfterRenovationWithAllDevicesResponding?.length > 0 && (
                      <Badge 
                        bg="success" 
                        className="small clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie po remoncie - w pełni gotowe', 
                          selectedReport.data.shopsAfterRenovationWithAllDevicesResponding,
                          'Po remoncie w pełni gotowe'
                        )}
                      >
                        {selectedReport.data.shopsAfterRenovationWithAllDevicesResponding.length} w pełni gotowe
                      </Badge>
                    )}
                    {selectedReport.data?.shopsAfterRenovationWithNotAllDevices?.length > 0 && (
                      <Badge 
                        bg="warning" 
                        className="small ms-1 clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie po remoncie - niekompletne', 
                          selectedReport.data.shopsAfterRenovationWithNotAllDevices,
                          'Po remoncie niekompletne'
                        )}
                      >
                        {selectedReport.data.shopsAfterRenovationWithNotAllDevices.length} niekompletne
                      </Badge>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Detailed Shop Status Breakdown */}
      <Row className="mb-4">
        {/* Drogerie Otwarte - Szczegóły */}
        {selectedReport.data?.shopsOpenedCount > 0 && (
          <Col md={6} lg={3} className="mb-3">
            <Card className="shadow-sm h-100 border-success">
              <Card.Header className="bg-success text-white">
                <h6 className="mb-0 small">
                  <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                  Drogerie otwarte - detale
                </h6>
              </Card.Header>
              <Card.Body className="p-2">
                <div className="small">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Łącznie otwarte:</span>
                    <Badge bg="success">{selectedReport.data.shopsOpenedCount}</Badge>
                  </div>
                  {selectedReport.data?.shopsOpenedWithNoDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-warning">⚠️ Bez urządzeń:</span>
                      <Badge 
                        bg="warning" 
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie otwarte - bez urządzeń', 
                          selectedReport.data.shopsOpenedWithNoDevices,
                          'Otwarte bez urządzeń'
                        )}
                      >
                        {selectedReport.data.shopsOpenedWithNoDevices.length}
                      </Badge>
                    </div>
                  )}
                  {selectedReport.data?.shopsOpenedWithNotRespondingDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-danger">🚨 Problemy komunikacji:</span>
                      <Badge 
                        bg="danger"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie otwarte - problemy komunikacji', 
                          selectedReport.data.shopsOpenedWithNotRespondingDevices,
                          'Otwarte z problemami komunikacji'
                        )}
                      >
                        {selectedReport.data.shopsOpenedWithNotRespondingDevices.length}
                      </Badge>
                    </div>
                  )}
                  <hr className="my-2" />
                  <div className="d-flex justify-content-between">
                    <span className="fw-bold">Sprawne drogerie:</span>
                    <Badge bg="success">
                      {selectedReport.data.shopsOpenedCount - 
                       (selectedReport.data?.shopsOpenedWithNoDevices?.length || 0) - 
                       (selectedReport.data?.shopsOpenedWithNotRespondingDevices?.length || 0)}
                    </Badge>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        )}

        {/* Drogerie Zamknięte - Szczegóły */}
        {selectedReport.data?.shopsClosedCount > 0 && (
          <Col md={6} lg={3} className="mb-3">
            <Card className="shadow-sm h-100 border-secondary">
              <Card.Header className="bg-secondary text-white">
                <h6 className="mb-0 small">
                  <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                  Drogerie zamknięte - detale
                </h6>
              </Card.Header>
              <Card.Body className="p-2">
                <div className="small">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Łącznie zamknięte:</span>
                    <Badge bg="secondary">{selectedReport.data.shopsClosedCount}</Badge>
                  </div>
                  {selectedReport.data?.shopsClosedWithDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-warning">⚠️ Z urządzeniami:</span>
                      <Badge 
                        bg="warning"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie zamknięte - z urządzeniami', 
                          selectedReport.data.shopsClosedWithDevices,
                          'Zamknięte z urządzeniami'
                        )}
                      >
                        {selectedReport.data.shopsClosedWithDevices.length}
                      </Badge>
                    </div>
                  )}
                  <hr className="my-2" />
                  <div className="d-flex justify-content-between">
                    <span className="fw-bold">Poprawnie zamknięte:</span>
                    <Badge bg="success">
                      {selectedReport.data.shopsClosedCount - (selectedReport.data?.shopsClosedWithDevices?.length || 0)}
                    </Badge>
                  </div>
                  <div className="mt-2 text-muted" style={{fontSize: '0.7em'}}>
                    Poprawnie = bez urządzeń w systemie
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        )}

        {/* Drogerie w Remoncie - Szczegóły */}
        {selectedReport.data?.shopsInRenovation > 0 && (
          <Col md={6} lg={3} className="mb-3">
            <Card className="shadow-sm h-100 border-warning">
              <Card.Header className="bg-warning text-dark">
                <h6 className="mb-0 small">
                  <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                  W remoncie - detale
                </h6>
              </Card.Header>
              <Card.Body className="p-2">
                <div className="small">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Łącznie w remoncie:</span>
                    <Badge bg="warning">{selectedReport.data.shopsInRenovation}</Badge>
                  </div>
                  {selectedReport.data?.shopsInRenovationWithDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-info">🔧 Z urządzeniami:</span>
                      <Badge 
                        bg="info"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie w remoncie - z urządzeniami', 
                          selectedReport.data.shopsInRenovationWithDevices,
                          'W remoncie z urządzeniami'
                        )}
                      >
                        {selectedReport.data.shopsInRenovationWithDevices.length}
                      </Badge>
                    </div>
                  )}
                  {selectedReport.data?.shopsInRenovationWithoutDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-secondary">⚪ Bez urządzeń:</span>
                      <Badge 
                        bg="secondary"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie w remoncie - bez urządzeń', 
                          selectedReport.data.shopsInRenovationWithoutDevices,
                          'W remoncie bez urządzeń'
                        )}
                      >
                        {selectedReport.data.shopsInRenovationWithoutDevices.length}
                      </Badge>
                    </div>
                  )}
                  {selectedReport.data?.shopsInRenovationWithNotAllDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-warning">⚠️ Niekompletne zestawy:</span>
                      <Badge 
                        bg="warning"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie w remoncie - niekompletne zestawy', 
                          selectedReport.data.shopsInRenovationWithNotAllDevices,
                          'W remoncie z niekompletnymi zestawami'
                        )}
                      >
                        {selectedReport.data.shopsInRenovationWithNotAllDevices.length}
                      </Badge>
                    </div>
                  )}
                  <div className="mt-2 text-muted" style={{fontSize: '0.7em'}}>
                    Kompletny zestaw: MA + MK + MKS
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        )}

        {/* Drogerie po remoncie - Szczegóły */}
        {selectedReport.data?.shopsAfterRenovation?.length > 0 && (
          <Col md={6} lg={3} className="mb-3">
            <Card className="shadow-sm h-100 border-info">
              <Card.Header className="bg-info text-white">
                <h6 className="mb-0 small">
                  <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                  Po remoncie - detale
                </h6>
              </Card.Header>
              <Card.Body className="p-2">
                <div className="small">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Łącznie po remoncie:</span>
                    <Badge bg="info">{selectedReport.data.shopsAfterRenovation.length}</Badge>
                  </div>
                  {selectedReport.data?.shopsAfterRenovationWithDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-primary">📱 Z urządzeniami:</span>
                      <Badge 
                        bg="primary"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie po remoncie - z urządzeniami', 
                          selectedReport.data.shopsAfterRenovationWithDevices,
                          'Po remoncie z urządzeniami'
                        )}
                      >
                        {selectedReport.data.shopsAfterRenovationWithDevices.length}
                      </Badge>
                    </div>
                  )}
                  {selectedReport.data?.shopsAfterRenovationWithAllDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-success">✅ Pełny zestaw:</span>
                      <Badge 
                        bg="success"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie po remoncie - pełny zestaw', 
                          selectedReport.data.shopsAfterRenovationWithAllDevices,
                          'Po remoncie z pełnym zestawem'
                        )}
                      >
                        {selectedReport.data.shopsAfterRenovationWithAllDevices.length}
                      </Badge>
                    </div>
                  )}
                  {selectedReport.data?.shopsAfterRenovationWithAllDevicesResponding?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-success">🚀 W pełni sprawne:</span>
                      <Badge 
                        bg="success"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie po remoncie - w pełni sprawne', 
                          selectedReport.data.shopsAfterRenovationWithAllDevicesResponding,
                          'Po remoncie w pełni sprawne'
                        )}
                      >
                        {selectedReport.data.shopsAfterRenovationWithAllDevicesResponding.length}
                      </Badge>
                    </div>
                  )}
                  {selectedReport.data?.shopsAfterRenovationWithNotRespondingDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-danger">🚨 Problemy komunikacji:</span>
                      <Badge 
                        bg="danger"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie po remoncie - problemy komunikacji', 
                          selectedReport.data.shopsAfterRenovationWithNotRespondingDevices,
                          'Po remoncie z problemami komunikacji'
                        )}
                      >
                        {selectedReport.data.shopsAfterRenovationWithNotRespondingDevices.length}
                      </Badge>
                    </div>
                  )}
                  {selectedReport.data?.shopsAfterRenovationWithoutDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-warning">⚠️ Bez urządzeń:</span>
                      <Badge 
                        bg="warning"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie po remoncie - bez urządzeń', 
                          selectedReport.data.shopsAfterRenovationWithoutDevices,
                          'Po remoncie bez urządzeń'
                        )}
                      >
                        {selectedReport.data.shopsAfterRenovationWithoutDevices.length}
                      </Badge>
                    </div>
                  )}
                  {selectedReport.data?.shopsAfterRenovationWithNotAllDevices?.length > 0 && (
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-warning">⚠️ Niekompletne:</span>
                      <Badge 
                        bg="warning"
                        className="clickable-badge"
                        style={{cursor: 'pointer'}}
                        onClick={() => onHandleShopListModal(
                          'Drogerie po remoncie - niekompletne', 
                          selectedReport.data.shopsAfterRenovationWithNotAllDevices,
                          'Po remoncie niekompletne'
                        )}
                      >
                        {selectedReport.data.shopsAfterRenovationWithNotAllDevices.length}
                      </Badge>
                    </div>
                  )}
                  <div className="mt-2 text-muted" style={{fontSize: '0.7em'}}>
                    {selectedReport.data?.timeToInformAboutRenovationEndInDays && 
                      `Ostatnie ${selectedReport.data.timeToInformAboutRenovationEndInDays} dni`}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>

      {/* Issues Section */}
      {(selectedReport.data?.shopsOpenedWithNoDevices?.length > 0 ||
       selectedReport.data?.shopsOpenedWithNotRespondingDevices?.length > 0 ||
       selectedReport.data?.shopsClosedWithDevices?.length > 0 ||
       selectedReport.data?.shopsAfterRenovationWithNotAllDevices?.length > 0) && (
        <Row className="mb-4">
          <Col md={12}>
            <Card className="shadow-sm border-warning">
              <Card.Header className="bg-warning text-dark">
                <h6 className="mb-0">
                  <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                  Wymagają uwagi - problemy operacyjne
                </h6>
              </Card.Header>
              <Card.Body>
                <Row>
                  {selectedReport.data?.shopsOpenedWithNoDevices?.length > 0 && (
                    <Col md={6} lg={3} className="mb-3">
                      <div className="alert alert-danger mb-0 p-2">
                        <div className="fw-bold small">🚨 OTWARTE BEZ URZĄDZEŃ</div>
                        <div className="h5 mb-1">{selectedReport.data.shopsOpenedWithNoDevices.length}</div>
                        <div className="small text-muted">
                          Drogerie: {selectedReport.data.shopsOpenedWithNoDevices.slice(0, 3).join(', ')}
                          {selectedReport.data.shopsOpenedWithNoDevices.length > 3 && ` +${selectedReport.data.shopsOpenedWithNoDevices.length - 3}`}
                        </div>
                      </div>
                    </Col>
                  )}
                  
                  {selectedReport.data?.shopsOpenedWithNotRespondingDevices?.length > 0 && (
                    <Col md={6} lg={3} className="mb-3">
                      <div className="alert alert-warning mb-0 p-2">
                        <div className="fw-bold small">⚠️ PROBLEMY KOMUNIKACJI</div>
                        <div className="h5 mb-1">{selectedReport.data.shopsOpenedWithNotRespondingDevices.length}</div>
                        <div className="small text-muted">
                          Drogerie: {selectedReport.data.shopsOpenedWithNotRespondingDevices.slice(0, 3).join(', ')}
                          {selectedReport.data.shopsOpenedWithNotRespondingDevices.length > 3 && ` +${selectedReport.data.shopsOpenedWithNotRespondingDevices.length - 3}`}
                        </div>
                      </div>
                    </Col>
                  )}
                  
                  {selectedReport.data?.shopsClosedWithDevices?.length > 0 && (
                    <Col md={6} lg={3} className="mb-3">
                      <div className="alert alert-info mb-0 p-2">
                        <div className="fw-bold small">ℹ️ ZAMKNIĘTE Z URZĄDZENIAMI</div>
                        <div className="h5 mb-1">{selectedReport.data.shopsClosedWithDevices.length}</div>
                        <div className="small text-muted">
                          Drogerie: {selectedReport.data.shopsClosedWithDevices.slice(0, 3).join(', ')}
                          {selectedReport.data.shopsClosedWithDevices.length > 3 && ` +${selectedReport.data.shopsClosedWithDevices.length - 3}`}
                        </div>
                      </div>
                    </Col>
                  )}
                  
                  {selectedReport.data?.shopsAfterRenovationWithNotAllDevices?.length > 0 && (
                    <Col md={6} lg={3} className="mb-3">
                      <div className="alert alert-secondary mb-0 p-2">
                        <div className="fw-bold small">🔧 PO REMONCIE - NIEKOMPLETNE</div>
                        <div className="h5 mb-1">{selectedReport.data.shopsAfterRenovationWithNotAllDevices.length}</div>
                        <div className="small text-muted">
                          Drogerie: {selectedReport.data.shopsAfterRenovationWithNotAllDevices.slice(0, 3).join(', ')}
                          {selectedReport.data.shopsAfterRenovationWithNotAllDevices.length > 3 && ` +${selectedReport.data.shopsAfterRenovationWithNotAllDevices.length - 3}`}
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Note: Additional shop status sections would continue here */}
    </>
  );
};

export default ShopStatusSection;